/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmEmailReplacementRequestOmitted
 */
export interface ConfirmEmailReplacementRequestOmitted {
    /**
     * 
     * @type {string}
     * @memberof ConfirmEmailReplacementRequestOmitted
     */
    token: string;
}

/**
 * Check if a given object implements the ConfirmEmailReplacementRequestOmitted interface.
 */
export function instanceOfConfirmEmailReplacementRequestOmitted(value: object): value is ConfirmEmailReplacementRequestOmitted {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ConfirmEmailReplacementRequestOmittedFromJSON(json: any): ConfirmEmailReplacementRequestOmitted {
    return ConfirmEmailReplacementRequestOmittedFromJSONTyped(json, false);
}

export function ConfirmEmailReplacementRequestOmittedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmEmailReplacementRequestOmitted {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function ConfirmEmailReplacementRequestOmittedToJSON(json: any): ConfirmEmailReplacementRequestOmitted {
    return ConfirmEmailReplacementRequestOmittedToJSONTyped(json, false);
}

export function ConfirmEmailReplacementRequestOmittedToJSONTyped(value?: ConfirmEmailReplacementRequestOmitted | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

